/**
 * Query Editor Workspace Type
 *
 * This module registers the query editor with the workspace registry.
 * Import this module to ensure the query editor is available.
 */

import { registerWorkspaceComponent } from '../core/registry/workspaceRegistry';
import { QueryEditorTab } from './components/QueryEditorTab';

// Register the query editor component
registerWorkspaceComponent('query', QueryEditorTab);

// Re-export components for direct use
export { QueryEditorTab } from './components/QueryEditorTab';
export { QueryEditor } from './components/QueryEditor';
export { QueryToolbar } from './components/QueryToolbar';
export { QueryStatusBar } from './components/QueryStatusBar';

// Re-export hooks
export { useQueryExecution } from './hooks/useQueryExecution';

// Re-export services
export { transformQueryResult } from './services/queryResultTransformer';
export type { RawQueryResult, TransformedColumn, TransformedResult } from './services/queryResultTransformer';
